import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Loading from "../../cross/Loading";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import IPlan from "../../entities/IPlan";
import IPlanificacion from "../../entities/IPlanificacion";
import { E_EstadoPlanificacion } from "../../enums/E_EstadoProveedor";
import { getAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { API_PROVEEDOR_GET_PLANIFICACIONES, API_ROLES_USERS, URL_PROVIDER, URL_SUPPORT } from "../../helpers/variableHelper";
import AgregarPlanificacion from "./AgregarPlanificacion";
import AgregarPrograma from "./AgregarPrograma";
import Evaluacion from "./Evaluacion";
import Medidas from "./Medidas";
import IMedidas from "../../entities/IMedidas";

interface IStepsProveedoresProps {
  is_test?: boolean;
}

export default function StepsProveedor({ is_test = false }: IStepsProveedoresProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  let search = new URLSearchParams(window.location.search);
  const idProveedor = parseInt(search.get("id") || (is_test ? "1" : "0"));
  const id_planificacion = parseInt(search.get("id_planificacion") || (is_test ? "1" : "0"));
  const id_evaluacion = parseInt(search.get("id_evaluacion") || (is_test ? "1" : "0"));
  const newPlanif = parseInt(search.get("new") || "0");
  const [isAdmin, setIsAdmin] = useState(false);

  const [plan, setPlan] = useState<IPlan>();

  const [planificacion, setPlanificacion] = useState<IPlanificacion>();

  const [medidas, setMedidas] = useState<Array<IMedidas>>([]);
  const [correlativoPlan, setCorrelativoPlan] = useState<string>("");
  usePromiseEffect(async () => {
    const userInfo = cognitoUserToken();
    let token = await userInfo;
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const roles = is_test
      ? { data: [{ ACTIVO: true, ID_ROLES: [47] }] }
      : (
          await getAPI(
            `${URL_SUPPORT}${API_ROLES_USERS}/getall`,
            { Authorization: `Bearer ${token}` },
            {
              USUARIO_DISPLAY: currUser.email,
              ACTIVO: true,
              PAGINA: 1,
              PAGINADO: 10000,
              ORIENTACION: "DESC",
              ORDENADOPOR: "ID",
            }
          )
        ).result;

    let tiene_rol = roles.data.some((d: any) => d.ACTIVO === true && d.ID_ROLES.some((id: number) => id === 47 || id === 49));
    setIsAdmin(tiene_rol);
    if (!tiene_rol && idProveedor === 0) {
      window.location.href = "/proveedores/home";
    }

    if (idProveedor > 0) {
      let resultPlan: IPlan = is_test
        ? {}
        : (await getAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/${idProveedor}`, { Authorization: `Bearer ${token}` })).result.data;
      setPlan(resultPlan);
    }
    let planif;
    if (id_planificacion > 0) {
      planif = is_test
        ? ({ CORRELATIVO: "ss-ss" } as IPlanificacion)
        : ((await getAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetPlan/${id_planificacion}`, { Authorization: `Bearer ${token}` }))
            .result.data as IPlanificacion);

      setPlanificacion(planif);
      let arrayCorrelativo = planif.CORRELATIVO.split("-");
      setCorrelativoPlan(arrayCorrelativo[0] + "-" + arrayCorrelativo[1]);
    }

    if (id_evaluacion > 0) {
      let resultMedida = is_test
        ? { data: [] }
        : (
            await getAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getmedidas/${id_evaluacion}/${planif?.ID_ESTADO}`, {
              Authorization: `Bearer ${token}`,
            })
          ).result;
      setMedidas(resultMedida.data);
    }
    setIsLoading(false);
  }, []);

  const isEvaluator = (evaluators?: string, currUser?: ICurrentUser) => {
    if (evaluators !== undefined && evaluators !== null) {
      let arrayEvaluadores = evaluators.split("; ");
      const isEvaluator = arrayEvaluadores.some((evaluator) => evaluator.trim() === currUser?.email);
      return isEvaluator;
    }
    return false;
  };
  const selectActiveTab = () => {
    if (
      (idProveedor > 0 &&
        plan?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado &&
        id_planificacion === 0 &&
        plan?.RESPONSABLE === currentUser?.email) ||
      newPlanif === 1
    ) {
      return "planificacion";
    }
    if (
      (id_planificacion > 0 && planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado) ||
      (planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
        medidas !== undefined &&
        medidas.length === 0 &&
        planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email)
    ) {
      return "evaluacion";
    }
    if (
      medidas !== undefined &&
      medidas.length === 0 &&
      planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email &&
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado
    ) {
      return "medidas";
    } else if (
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada
    ) {
      console.log("");
      return "medidas";
    }

    return "ingreso";
  };
  const showMedidasTab = () => {
    if (
      medidas !== undefined &&
      medidas.length === 0 &&
      planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email &&
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados
    ) {
      return true;
    } else if (
      medidas !== undefined &&
      medidas.length > 0 &&
      (planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
        planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
        planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
        planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
        planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
        planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada)
    ) {
      console.log("");
      return true;
    }
    return false;
  };
  return (
    <div className="col-12">
      -
      <div className="rounded bg-white p-2 shadow">
        {isLoading ? (
          <Loading />
        ) : (
          <Tabs defaultActiveKey={selectActiveTab()} id="uncontrolled-tab-example" className="mb-3">
            <Tab
              eventKey="ingreso"
              title={
                <span>
                  Programa Anual <i className="bi bi-eye" />{" "}
                </span>
              }>
              <AgregarPrograma plan={plan} correlativo={correlativoPlan} />
            </Tab>
            {((plan?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado &&
              (plan?.RESPONSABLE === currentUser?.email ||
                isEvaluator(planificacion?.EVALUADORES, currentUser) ||
                planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email ||
                planificacion?.EVALUADOR_LIDER === currentUser?.email ||
                isAdmin)) ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada) &&
              idProveedor > 0 && (
                <Tab
                  eventKey="planificacion"
                  title={
                    <span>
                      Planificación <i className="bi bi-eye" />{" "}
                    </span>
                  }>
                  <AgregarPlanificacion plan={plan} planif={planificacion} />
                </Tab>
              )}
            {(planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada) && (
              <Tab
                eventKey="evaluacion"
                title={
                  <span>
                    Evaluacion <i className="bi bi-eye" />{" "}
                  </span>
                }>
                <Evaluacion id_evaluacion={id_evaluacion} plan={plan} planif={planificacion} />
              </Tab>
            )}
            {id_evaluacion > 0 && showMedidasTab() && (
              <Tab
                eventKey="medidas"
                title={
                  <span>
                    Medidas <i className="bi bi-eye" />{" "}
                  </span>
                }>
                <Medidas id_evaluacion={id_evaluacion} planificacion={planificacion} />
              </Tab>
            )}
          </Tabs>
        )}
      </div>
    </div>
  );
}
